export default __webpack_public_path__ + "static/media/corner.4aae9718.svg";